module.exports = __webpack_public_path__ + "static/media/风BU1623彩钢.ba2589a0.pdf";